"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendRedPacketSession = void 0;
const rxjs_1 = require("rxjs");
const AccountService_1 = require("../AccountService");
const BaseWithdrawSession_1 = require("./BaseWithdrawSession");
/**
 * 发红包验证逻辑
 */
class SendRedPacketSession extends BaseWithdrawSession_1.BaseWithdrawSession {
    constructor(params) {
        super(params, AccountService_1.VerifyCodeAction.gift_box_send);
    }
    start(params, device_info) {
        super.startSession(params, device_info, (mfaParams) => (0, rxjs_1.of)(mfaParams));
    }
}
exports.SendRedPacketSession = SendRedPacketSession;
